import React from 'react';

interface workTimeCompilerProp {
    oldWorkTime: Array<any>;
    newWorkTime: Array<any>;
}

const workTimeCompiler = ({
  oldWorkTime,
  newWorkTime,
}: workTimeCompilerProp) => {
  const toPatchTimes = oldWorkTime.length > 0 && JSON.stringify(newWorkTime) !== JSON.stringify(oldWorkTime) ?
    [
      {
        daysPeriods: newWorkTime[0].daysPeriods,
        period: newWorkTime[0].period,
        targetPeriod: oldWorkTime[0].period
      }
    ] : []

  const toAddTimes = JSON.stringify(newWorkTime) !== JSON.stringify(oldWorkTime) ?
    newWorkTime : []

  return {toPatchTimes, toAddTimes}
}

interface DaysOffCompilerProp {
    oldDaysOff: Array<any>;
    newDaysOff: Array<any>;
    patchedDaysOff: Array<any>;
}

const DaysOffCompiler = ({
  oldDaysOff,
  newDaysOff,
  patchedDaysOff,
}: DaysOffCompilerProp) => {
  const oldDaysOffWithTarget = oldDaysOff.map((day: any) => {
    return {
      period: day.period,
      targetPeriod: day.period,
      reason: day.reason,
    }
  });

  const precursorForPatchDaysOff = patchedDaysOff.map((patchDay: any) => {
    const matchingDay = newDaysOff.find((day: any) =>
      JSON.stringify(day.period) === JSON.stringify(patchDay.period)
    );
    if (matchingDay) {
      return {
        ...patchDay,
        reason: matchingDay.reason,
      };
    } else {
      return { ...patchDay };
    }
  })

  const toAddDaysOff = precursorForPatchDaysOff.filter((patchDay: any) => {
    const targetPeriodExists = oldDaysOffWithTarget.some((oldDay: any) => {
      return (
        oldDay.targetPeriod.from === patchDay.targetPeriod.from &&
        oldDay.targetPeriod.to === patchDay.targetPeriod.to
      );
    });
    return !targetPeriodExists;
  }).map((addDay: any) => { return {period: addDay.period, reason: addDay.reason}});

  const toPatchDaysOff = precursorForPatchDaysOff.filter((precursorDay: any) => {
    const periodExists = toAddDaysOff.some((addDay: any) => {
      return (
        addDay.period.from === precursorDay.period.from &&
        addDay.period.to === precursorDay.period.to
      );
    });
    return !periodExists;
  })
    .filter(toPatchObj => {
      return !oldDaysOffWithTarget.some(oldObj =>
        oldObj.period.from === toPatchObj.period.from &&
        oldObj.period.to === toPatchObj.period.to &&
        oldObj.reason === toPatchObj.reason
      );
    });

  return {
    toAddDaysOff,
    toPatchDaysOff,
  }
}

interface holidaysCompilerProp {
    oldHolidays: Array<any>;
    newHolidays: Array<any>;
}

const holidaysCompiler = ({
  oldHolidays,
  newHolidays,
}: holidaysCompilerProp) => {
  const toAddHolidays = newHolidays.filter((newValue: any) => {
    return !oldHolidays.some((oldValue: any) =>
      JSON.stringify(oldValue) === JSON.stringify(newValue)
    );
  });
  const toDeleteHolidays = oldHolidays
    .filter((oldValue: any) => {
      return !newHolidays.some((newValue: any) =>
        JSON.stringify(oldValue) === JSON.stringify(newValue)
      )})
    .map((holiday: any) => ({
      from: holiday.date,
      to: holiday.date,
    }));

  const toPatchHolidays = newHolidays
    .filter((normValue: any) => {
      return !toDeleteHolidays.some((deleteValue: any) =>
        JSON.stringify(deleteValue) === JSON.stringify(normValue)
      ) && !toAddHolidays.some((addValue: any) =>
        JSON.stringify(addValue) === JSON.stringify(normValue)
      );
    })
    .filter((normValue: any) => {
      return !oldHolidays.some((oldValue: any) =>
        JSON.stringify(oldValue) === JSON.stringify(normValue)
      );
    });

  return {
    toAddHolidays,
    toDeleteHolidays,
    toPatchHolidays,
  }
}

interface scheduleDataCompilerProp {
    oldWorkTime: Array<any>;
    newWorkTime: Array<any>;
    oldDaysOff: Array<any>;
    newDaysOff: Array<any>;
    deletedDaysOff: Array<any>;
    patchedDaysOff: Array<any>;
    oldHolidays: Array<any>;
    newHolidays: Array<any>;
    studioId: number;
}

export const scheduleDataCompiler = ({
  oldWorkTime,
  newWorkTime,
  oldDaysOff,
  newDaysOff,
  deletedDaysOff,
  patchedDaysOff,
  oldHolidays,
  newHolidays,
  studioId,
}: scheduleDataCompilerProp) => {
  const { toPatchTimes, toAddTimes} = workTimeCompiler({ oldWorkTime, newWorkTime });

  const { toAddDaysOff, toPatchDaysOff } = DaysOffCompiler({ oldDaysOff, newDaysOff, patchedDaysOff });
  const toDeleteDaysOff = deletedDaysOff;

  const { toAddHolidays, toDeleteHolidays, toPatchHolidays } = holidaysCompiler({ oldHolidays, newHolidays })

  const updateValues = {
    currentId: studioId,
    params: [
      {
        values: toAddTimes,
        tag: 'working-time',
        operation: 'add',
      },
      {
        values: toPatchTimes,
        tag: 'working-time',
        operation: 'update',
      },
      {
        values: toDeleteHolidays,
        tag: 'holiday',
        operation: 'delete',
      },
      {
        values: toAddHolidays,
        tag: 'holiday',
        operation: 'add',
      },
      {
        values: toPatchHolidays,
        tag: 'holiday',
        operation: 'update',
      },
      {
        values: toDeleteDaysOff,
        tag: 'day-off',
        operation: 'delete',
      },
      {
        values: toAddDaysOff,
        tag: 'day-off',
        operation: 'add',
      },
      {
        values: toPatchDaysOff,
        tag: 'day-off',
        operation: 'update',
      },
    ].filter(obj => obj.values.length > 0)
  };

  return updateValues
}
